import { Navigate } from 'react-router-dom';
import { isTokenValid } from './TokenHandler';

const ProtectedRoute = ({ element }) => {
    return isTokenValid() ? element : <Navigate to="/" />;
};

export default ProtectedRoute;
